namespace TabAurous.SalesOrder {
    export namespace OrderItemsService {
        export const baseUrl = 'SalesOrder/OrderItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/OrderItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
